/**
 * The backend answers requests for a maintenance offer that can no longer be accepted (already
 * accepted, expired, an active maintenance contract or T365) with Django REST framework's JSON
 * 404, `{ "detail": ... }`. That is an expected outcome, not an error (SALES-2576). A deleted
 * or unknown offer id also gets a JSON 404, only with a different `detail` text, and is treated
 * the same. Any other 404 (an HTML page from the router, a missing route) stays a real failure.
 */
const isMaintenanceOfferUnavailable = (error, mode) => {
    const response = error?.response;

    return mode === 'maintenanceOffer'
        && response?.status === 404
        && typeof response.data === 'object'
        && response.data !== null
        && 'detail' in response.data;
};

export { isMaintenanceOfferUnavailable as default };
